<script>
  import dialogMixin from "./mixins/dialog";
  import File from "@components/List/File";
  import {
    eventLocationContent,
    eventLocationTitle,
    eventTimeRange,
  } from "@utils/zerone-event";
  import formatDate from "@utils/format-date";

  export default {
    components: {
      File,
      ListPersonnels: () => import('@components/List/Personnels')
    },
    mixins: [dialogMixin],
    props: {
      sessionItem: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isMobileSize: false,
      }
    },
    computed: {
      dateTimeRange() {
        const timeRange = eventTimeRange({ ...this.sessionItem });
        const date = formatDate(this.sessionItem.date, 'yyyy/MM/dd(EEE)');

        return `${ date } (${ timeRange })`
      },
      locationTitle() {
        return eventLocationTitle(this.sessionItem.eventType, this.sessionItem.categoryTitle)
      },
      locationContent() {
        return eventLocationContent({ ...this.sessionItem })
      },
    },
    mounted() {
      const initResizeListener = () => {
        window.addEventListener('resize', this.onMobileSize)
      };

      this.onMobileSize();
      initResizeListener();
    },
    destroyed() {
      const removeResizeListener = () => {
        window.removeEventListener('resize', this.onMobileSize)
      };

      removeResizeListener();
    },
    methods: {
      onMobileSize() {
        this.isMobileSize = document.body.clientWidth <= 767
      },
    },
  }
</script>
<template>
  <div>
    <el-dialog
      :visible.sync="dialogMixinDialogVisible"
      :before-close="$DialogMixinOnClose"
      custom-class="isStyleCourseContentDialog"
      :fullscreen="isMobileSize"
    >
      <template v-slot:title>
        <!-- <div class="d-md-none detail__mobileHeader d-flex justify-content-between">
          <div @click="$DialogMixinOnClose">
            <i class="far fa-long-arrow-left text-2xl"></i>
          </div>
          <span>
            議程詳情
          </span>
          <div></div>
        </div> -->
        <div class="detail__headerTitle">{{ sessionItem.title }}</div>
      </template>
      <el-divider></el-divider>
      <div :class="$style.detail">
        <div class="row detail__box detail__session">
          <div class="col-md-5 col-12">
            <p class="detail__title"><i class="icomoon icon-time"></i>{{sessionItem.categoryTitle || '活動'}}時間</p>
            <span class="detail__content">{{ dateTimeRange }}</span>
          </div>
          <div class="col-md-7 col-12 mt-md-0 mt-3">
            <p class="detail__title"><i class="icomoon icon-location"></i>{{ locationTitle }}</p>
            <span
              class="detail__content"
              v-html="locationContent"
            >
            </span>
          </div>
        </div>
        <div
          v-if="!!sessionItem.description"
          class="detail__box detail__inrto"
        >
          <div class="detail__title">
            <el-divider content-position="left" class="isStyleDialog">{{sessionItem.categoryTitle || '活動'}}簡介</el-divider>
          </div>
          <div
            class="detail__content article"
            v-html="sessionItem.description"
          >
          </div>
        </div>
        <div
          v-if="sessionItem.personnels && !!sessionItem.personnels[0]"
          class="detail__box detail__teacher"
        >
          <div class="detail__title">
            <el-divider content-position="left" class="isStyleDialog">講師介紹</el-divider>
          </div>
          <ListPersonnels
            :personnel-list="sessionItem.personnels"
          />
        </div>
        <div
          v-if="sessionItem.files && !!sessionItem.files[0]"
          class="detail__box detail__file"
        >
          <div class="detail__title">
            <el-divider content-position="left" class="isStyleDialog">附加檔案</el-divider>
          </div>
          <div v-for="(fileItem, index) in sessionItem.files" :key="index" class="mt-3">
            <File
              type="download"
              :item="fileItem"
              icon="<i class='icomoon icon-download'></i>"
            />
          </div>
        </div>
      </div>
      <BasePre>{{ sessionItem }}</BasePre>
    </el-dialog>
  </div>
</template>
<style lang="scss" module>
  .detail {
    // p {
    //   margin-bottom: 2.5rem;
    // }

    h3 {
      padding-top: 3rem;
      margin-bottom: 3rem;
      font-size: 1.875rem;
    }
    :global {
      .detail {
        // &__title {
        //   margin-bottom: 1.4rem;
        //   font-size: 1.25em;
        // }
        // &__content {
        //   margin-bottom: 3.75rem;
        //   color: $color-gray-6;
        // }
        &__content {
          a {
            color: $color-gray-7;

            &:hover {
              color: $color-primary;
              text-decoration: none;
            }
          }
        }
      }

      .el-timeline {
        margin-bottom: 2rem;
      }
    }
  }
</style>
